import { Suspense, lazy } from "react";
import { type RouteObject } from "react-router";

import type { DashboardWebhooksDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_WEBHOOKS_DETAILS_LOADER } from "@application/loaders/dashboard_webhooks_details_loader";
import { DASHBOARD_WEBHOOKS_FORM_LOADER } from "@application/loaders/dashboard_webhooks_form_loader";
import { DASHBOARD_WEBHOOKS_LIST_LOADER } from "@application/loaders/dashboard_webhooks_list_loader";

import { DASHBOARD_WEBHOOKS_LINK } from "@application/navigation/dashboard_webhooks_link";

import { Loader } from "@styled/loader";

const DashboardWebhooksDetails = lazy(() =>
  import("./webhooks_details").then((m) => ({
    default: m.DashboardWebhooksDetails,
  })),
);
const DashboardWebhooksEdit = lazy(() =>
  import("./webhooks_edit").then((m) => ({ default: m.DashboardWebhooksEdit })),
);
const DashboardWebhooksList = lazy(() =>
  import("./webhooks_list").then((m) => ({ default: m.DashboardWebhooksList })),
);
const DashboardWebhooksNew = lazy(() =>
  import("./webhooks_new").then((m) => ({ default: m.DashboardWebhooksNew })),
);

export const DASHBOARD_TRIGGERS_WEBHOOKS_ROUTE = {
  path: "webhooks",
  handle: DASHBOARD_WEBHOOKS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardWebhooksList />
        </Suspense>
      ),
      loader: DASHBOARD_WEBHOOKS_LIST_LOADER,
    },
    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardWebhooksNew />
        </Suspense>
      ),
      loader: DASHBOARD_WEBHOOKS_FORM_LOADER,
      handle: {
        name: "New",
        to: "/dashboard/triggers/webhooks/new",
      },
    },
    {
      path: ":id",
      loader: DASHBOARD_WEBHOOKS_DETAILS_LOADER,
      handle: (data: DashboardWebhooksDetailsQuery): Breadcrumb => ({
        name: data.webhook.description,
        to: `/dashboard/triggers/webhooks/${data.webhook.id}`,
      }),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardWebhooksDetails />
            </Suspense>
          ),
        },
        {
          path: "edit",
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardWebhooksEdit />
            </Suspense>
          ),
          loader: DASHBOARD_WEBHOOKS_FORM_LOADER,
          handle: { name: "Edit" },
        },
      ],
    },
  ],
} satisfies RouteObject;
